import type { LegalSection } from './legal-section';

export const TERMS_RULES: readonly LegalSection[] = [
  {
    title: '6. Tablas de precios y pagos',
    body: `Los pagos se procesan semanalmente (lunes) siempre que el saldo supere el umbral mínimo publicado en el dashboard. Por debajo de dicho umbral, el saldo se acumula al ciclo siguiente.`,
  },
  {
    title: '7. Liquidación tras expulsión (umbral mínimo)',
    body: `En caso de expulsión, el saldo se abonará si supera el umbral mínimo de liquidación. Si es inferior, los costes de red (gas) imposibilitan el pago, quedando el saldo a disposición del Collector para cobro asumiendo él dichos costes.`,
  },
  {
    title: '8. Obligaciones fiscales',
    body: `Debook NO actúa como retenedor. El Collector es responsable de la declaración fiscal de los importes recibidos en criptoactivos (IVA, IRPF, Modelo 721 o equivalentes internacionales).`,
  },
];
